import { StatusPill } from '@dreamtree-org/twreact-ui';

/**
 * One status → tone map for the whole app, so the same word is the same colour on every surface.
 * Unknown statuses render neutral and humanized ("in_review" → "In review"), never raw.
 */
const VARIANTS = {
  success: ['active', 'verified', 'published', 'delivered', 'completed', 'paid', 'settled', 'approved', 'succeeded', 'in_stock', 'resolved', 'passed', 'done', 'closed', 'ready_for_return', 'received', 'healthy'],
  warning: ['pending', 'provisioning', 'processing', 'in_progress', 'awaiting_approval', 'packed', 'reserved', 'review', 'pending_review', 'in_review', 'info_requested', 'flagged', 'submitted', 'quoted', 'open', 'diagnosis', 'scheduled', 'triaged', 'qc', 'awaiting_parts', 'draft', 'invited', 'degraded', 'paused'],
  primary: ['shipped', 'dispatched', 'accepted', 'assigned', 'out_for_delivery', 'picked_up', 'new', 'in_repair', 'pickup_scheduled', 'placed'],
  error: ['failed', 'provisioning_failed', 'suspended', 'cancelled', 'rejected', 'refunded', 'sold', 'overdue', 'breached', 'disputed', 'returned', 'declined', 'expired', 'exception', 'past_due', 'disabled', 'down'],
};
const LOOKUP = Object.fromEntries(Object.entries(VARIANTS).flatMap(([v, list]) => list.map((s) => [s, v])));
// primary is the page's one accent (DESIGN.md §2), so in-flight states read as info.
const TONE = { success: 'success', warning: 'warning', primary: 'info', error: 'danger', default: 'neutral' };

export const statusVariant = (status) => LOOKUP[String(status || '').toLowerCase()] || 'default';
export const statusTone = (status) => TONE[statusVariant(status)];

export default function StatusBadge({ status, label }) {
  const key = String(status || '').toLowerCase();
  return (
    <StatusPill tone={statusTone(key)} status={label ? undefined : key || undefined}>
      {label || (key ? undefined : '—')}
    </StatusPill>
  );
}
